import {
    SET_OWNERSHIP_STATUS,
    OWNERSHIP_STATUS,
    SET_PYC_GAME_ITEMS, SET_SELECTED_GAME_ITEM_ID
} from './pyc-redeem.constants';

import { PYCRedeemActions } from './pyc-redeem.actions';

import { IContentPackItem } from '@sitegen/common/types';

export interface IState {
    contentGameItems: IContentPackItem[];
    ownershipStatus: OWNERSHIP_STATUS;
    selectedGameItemId: string;
}

export const initialState: IState = {
    contentGameItems: [],
    ownershipStatus: OWNERSHIP_STATUS.OWNED_NOT_ALL_GAMES,
    selectedGameItemId: ''
};

export const reducerKey = 'PYCRedeemReducer' as const;

export const PYCRedeemReducer = (state = initialState, action: PYCRedeemActions): IState => {
    switch (action.type) {
    case SET_OWNERSHIP_STATUS:
        return {
            ...state,
            ownershipStatus: action.payload
        };
    case SET_PYC_GAME_ITEMS:
        return {
            ...state,
            contentGameItems: action.payload
        };
    case SET_SELECTED_GAME_ITEM_ID:
        return {
            ...state,
            selectedGameItemId: action.payload
        };
    default:
        return state;
    }
};

export default PYCRedeemReducer;
